export default {
    routes: [{
        path: '/profile',
        component: () => import('../pages/users/Profile.vue'),
        name: 'profile',
        meta: {
            name: 'Profile',
            title: window.titlePrefix
        }
    }, {
        path: '/users',
        component: () => import('../pages/users/Index.vue'),
        name: 'users.index',
        meta: {
            name: 'Users',
            title: window.titlePrefix,
            permissions: ['users.view']
        }
    }, {
        path: '/users/create',
        component: () => import('../pages/users/Edit.vue'),
        name: 'users.create',
        meta: {
            name: 'Users',
            title: window.titlePrefix,
            permissions: ['users.create']
        }
    }, {
        path: '/users/edit/:id',
        component: () => import('../pages/users/Edit.vue'),
        props: true,
        name: 'users.edit',
        meta: {
            name: 'Users',
            title: window.titlePrefix,
            permissions: ['users.edit']
        }
    }]
}